import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import EditorMPR from '../components/EditorMPR/EditorMPR';
import Button from '../components/ui/Button';
import './EditorPage.css';

function EditorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const pecaInicial = location.state?.peca ?? null;
  const rawProductId = new URLSearchParams(location.search).get('product_id');
  const parsedProductId = rawProductId && /^\d+$/.test(rawProductId) ? Number(rawProductId) : null;
  const productId = Number.isSafeInteger(parsedProductId) && parsedProductId > 0
    ? parsedProductId : null;

  // navigate(-1) em vez de navigate('/pecas'): preserva a busca (?produto=)
  // de onde o usuário veio, igual ao botão voltar do navegador.
  const handleVoltar = () => navigate(-1);

  const editor = <EditorMPR pecaInicial={pecaInicial} onVoltar={productId ? undefined : handleVoltar} />;
  if (productId == null) return editor;

  return (
    <div className="cw-editor-page">
      <div className="cw-editor-product-return">
        <Button variant="secondary" onClick={() => navigate(`/produtos/${productId}`)}>
          <ArrowLeft size={16} aria-hidden="true" />
          Voltar ao Produto
        </Button>
      </div>
      {editor}
    </div>
  );
}

export default EditorPage;
